import {createContext} from "react"

interface UIHelperContextInterface {
  snackMessage: string
  setSnackMessage: (message: string) => void
  showSnack: boolean
  setShowSnack: (open: boolean) => void
  showProgressBar: boolean
  setShowProgressBar: (isShow: boolean) => void
}

export const UIHelperContext = createContext<UIHelperContextInterface>({
  snackMessage: "",
  setSnackMessage: () => {},
  showSnack: false,
  setShowSnack: () => {},
  showProgressBar: false,
  setShowProgressBar: () => {}
})
